import { fillTranscriptionsActionType, DialogTranscriptionActionTypes, fillTranscriptionSpeechActionType, fillTranscriptionActionType } from '../../model/transcription/action';
import { Speech } from '../../model/transcription/types';
import { createActions } from '../../helpers/actionsHelper';


export const fillTranscriptionAction = createActions<DialogTranscriptionActionTypes, any, any>(fillTranscriptionsActionType);

export function fillTranscriptionSpeech(dialogId: string): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionSpeechActionType.request,
    payload: {
      dialogId,
    },
  };
}

export function fillTranscriptionSpeechSuccess(dialogId: string, speeches: Speech[]): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionSpeechActionType.success,
    payload: {
      speeches,
      dialogId,
    },
  };
}

export function fillTranscriptionSpeechFailure(): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionSpeechActionType.failure,
    payload: undefined,
  };
}

export function fillTranscription(dialogId: string): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionActionType.request,
    payload: {
      dialogId,
    },
  };
}

export function fillTranscriptionSuccess(dialogId: string, transcription: any): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionActionType.success,
    payload: {
      transcription,
      dialogId,
    },
  };
}

export function fillTranscriptionFailure(): DialogTranscriptionActionTypes {
  return {
    type: fillTranscriptionActionType.failure,
    payload: undefined,
  };
}

